export const PLAN_SUCCESS = {type: "PLAN_SUCCESS"}